module.exports = __webpack_public_path__ + "static/media/background.fd7ae5e7.png";